import { Link } from "react-router-dom"

export default function HomeTutorialSection() {
  return (
    <div className="home-subsection-rounded-container" id="tutorial">
      <div className="row pt-4 text-center">
        <h1 className="mt-4 home-subsection-subtitle">Vuoi comprare una gift card?</h1>
      </div>
      <div className="row p-4">
        <div className="d-flex justify-content-center pt-4 flex-column flex-md-row">
          <div className="col-12 col-md-2 text-center pt-4 pb-4">
            <img src={`${process.env.PUBLIC_URL}/img/home/home_step_1.png`} alt="Step 1" />
            <h5 style={{ fontSize: "24px" }} className="mt-4">
              Scegli il suo valore!
            </h5>
            <p>
              Puoi scegliere una gift card del valore che preferisci: potr&agrave; essere utilizzata in pi&ugrave; di un
              negozio fino all&apos;esaurimento del credito!
            </p>
          </div>
          <div className="col-1 d-none d-md-block"></div>
          <div className="col-12 col-md-2 text-center pt-4 pb-4">
            <img src={`${process.env.PUBLIC_URL}/img/home/home_step_2.png`} alt="Step 2" />
            <h5 style={{ fontSize: "24px" }} className="mt-4">
              Un regalo sempre gradito
            </h5>
            <p>
              Riceverai le Gift Card acquistate sul sito Buoni sul Serio istantaneamente e ti verranno inviate via mail
              all&apos;indirizzo inserito al momento dell&apos;acquisto. Potrai poi stamparla e consegnarla al
              destinatario o inviarla via mail o Whatsapp!
            </p>
          </div>
          <div className="col-1 d-none d-md-block"></div>
          <div className="col-12 col-md-2 text-center pt-4 pb-4">
            <img src={`${process.env.PUBLIC_URL}/img/home/home_step_3.png`} alt="Step 3" />
            <h5 style={{ fontSize: "24px" }} className="mt-4">
              Supporta il commercio locale
            </h5>
            <p>
              Le Gift Card di Buoni Sul Serio, possono essere spese in tutte le attività del Distretto del Commercio
              aderenti all&apos;iniziativa. Le trovi tutte sul sito!
            </p>
          </div>
        </div>
      </div>
      <div className="row pb-4">
        <div className="col text-center">
          <Link to="/acquista-gift-card">
            <button className={"btn btn-violet"}>Acquista una Gift Card</button>
          </Link>
        </div>
      </div>
    </div>
  )
}
